// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__Hgfxg","innerContainer":"Footer_innerContainer__Ko019","iconContainer":"Footer_iconContainer__VUbUu","iconItem":"Footer_iconItem__hWBET"};